import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useKidListFunctionality from "../../../../customHooks/kidListHook";
import useLangTranslation from "../../../../customHooks/languageProvider";
import useFirebase from "../../../../../useFirebase";
import useTimeSupervision from "../TimeSupervision/useTimeSupvervision";
import ScreenShotTableRow from "./ScreenShotTableRow";
// import { AlertModal } from "../../../../../setup/alert/swalAlert";
// import { alertIconType } from "../../../../../setup/alert/iconTypes";
import SetRulesDisableSupervison from "../SetRulesDisableSupervison";
import useSetRules from "../useSetRules";
import CommonStatus from "../../Common/CommonStatus";
import useDeviceStatus from "../../../../customHooks/deviceStatusProvider";
import { setShowMessage } from "../../../AxiosRtk/successMessage";
import Select from "react-select";
import useDurationOption from "../../../../customHooks/durationOption";
import { useDashboardDataProvider } from "../../../../customHooks/dashboardDataProvider";

import {
  videoNudityMonitor,
  screenshotSettings,
  appKeyStrokesStatus,
} from "../../../AxiosRtk/SetRules";

const pathKeys = {
  "/keystrokes-select-apps": { key: "isKeystrokeEnabled", type: "number" },
  "/screen-shot-select-apps": { key: "screenshotEnable", type: "number" },
  "/social-media-select-apps": {
    key: "socialMediaCommunicationStatus",
    type: "boolean",
  },
};

const ScreenShotsSelectApps = (props) => {
  // console.log(props);
  const pathname = props?.location?.pathname;
  const [deviceOptions, setDeviceOptions] = useState([]);
  // const isScreenShotApps = props?.location?.pathname === '/keystrokes-select-apps' ? false : true;
  const dispatch = useDispatch();
  const history = useHistory();
  const [normalFormattedAllowedApps, setNormalFormattedAllowedApps] = useState(
    []
  );
  const [allowedApps, setAllowedApps] = useState([]);
  const [kid, setKid] = useState(null);
  const [loader, setLoader] = useState(false);
  const { getLangTranslation } = useLangTranslation();
  const { daysAndWeekFunction } = useDurationOption();
  const daysAndWeekOptions = daysAndWeekFunction();
  const { getImage } = useKidListFunctionality();
  const { keyStrokesModifiedData } = useTimeSupervision();
  const { handleDeviceSelection } = useDashboardDataProvider();

  // console.log(device)
  // console.log("allowedApps ==>>", allowedApps)
  // console.log("normalFormattedAllowedApps ==>>", normalFormattedAllowedApps)
  const { kidList, selectedKidId, kidDevicesList, selectedDeviceData } =
    useSelector(({ dashboard }) => dashboard);

  const { setRulesData } = useSelector(({ setRules }) => setRules);

  const { getCollectionData, postCollectionData } = useFirebase();

  const { handleTimeSupervision } = useSetRules();

  const [deviceStatus, setDeviceStatus] = useState("");
  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );
  // const {  } = useSelector(({ setRules }) => setRules);
  // console.log("setRulesData ==>>", setRulesData)

  useEffect(() => {
    if (selectedKidId && kidList?.length > 0) {
      const kidData = kidList?.find((item) => item?.ID === selectedKidId);
      console.log("---->Kidzlist", kidData);
      setKid(kidData);
    }
  }, [selectedKidId, kidList]);



  useEffect(() => {
    if (selectedDeviceData?.ID) {
      getDeviceStatusData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData]);

  useEffect(() => {
    if (selectedDeviceData?.ID) {
      getCollectionData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData]);

  useEffect(() => {
    if (setRulesData) {
      const tempAllowedApps = setRulesData?.timesupervison?.allowedApps ?? [];
      setNormalFormattedAllowedApps(tempAllowedApps);
      const modifiedData = keyStrokesModifiedData(tempAllowedApps);
      setAllowedApps(modifiedData);
    } else {
      setNormalFormattedAllowedApps([]);
    }
  }, [setRulesData]);
  // console.log(normalFormattedAllowedApps)

  function checkStatus(type, value) {
    if (type === "number") {
      return value ? 1 : 0;
    }
    return value;
  }
  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);
  function handleScreenShotSelect(e) {
    const { name, checked } = e.target;
    // console.log(name, checked, isScreenShotApps)
    let tempAllowedApps = [...normalFormattedAllowedApps];

    if (name === "allSelect") {
      tempAllowedApps = tempAllowedApps?.map((item) => {
        const tempObj = { ...item };
        tempObj[pathKeys[pathname]?.key] = checkStatus(
          pathKeys[pathname]?.type,
          checked
        );
        return tempObj;
      });
    } else {
      const indexToModified = tempAllowedApps?.findIndex(
        (item, index) => parseInt(item?.appUuid) === parseInt(name)
      );
      const gettingModifiableObj = { ...tempAllowedApps[indexToModified] };
      gettingModifiableObj[pathKeys[pathname]?.key] = checkStatus(
        pathKeys[pathname]?.type,
        checked
      );
      tempAllowedApps.splice(indexToModified, 1, gettingModifiableObj);
    }
    // console.log(tempAllowedApps)
    setNormalFormattedAllowedApps(tempAllowedApps);
    const modifiedData = keyStrokesModifiedData(tempAllowedApps);
    setAllowedApps(modifiedData);
  }

  function handleAllowedAppsSave() {
    if (normalFormattedAllowedApps?.length === 0) {
      return;
    }

    const collectionPayload = {
      ...setRulesData?.timesupervison,
      allowedApps: normalFormattedAllowedApps,
    };

    setLoader(true);
    // console.log("collectionPayload ==>>", collectionPayload)
    postCollectionData(selectedDeviceData?.ID, { timesupervison: collectionPayload })
      .then(() => {
        dispatch(
          setShowMessage({
            showMessage: true,
            defaultMessage: "Data saved successfully",
            message: "DATA_SAVED",
          })
        );
      })
      .catch((err) => {
        console.log("err response ==>>", err);
      })
      .finally(() => {
        setLoader(false);
      });
    getCollectionData(selectedDeviceData?.ID);

    const dbPayloadToAllowedApp = {
      kidId: selectedKidId,
      deviceId: parseInt(selectedDeviceData?.ID),
    };

    if (pathname === "/social-media-select-apps") {
      const allowAppsDBPayload = normalFormattedAllowedApps?.map((item) => {
        return {
          appPackageName: item?.appPackageName,
          isAllow: item?.socialMediaCommunicationStatus ? 1 : 0,
        };
      });

      dbPayloadToAllowedApp["SocialMediaApps"] = [...allowAppsDBPayload];

      videoNudityMonitor(dbPayloadToAllowedApp)
        .then((res) => {})
        .catch((err) =>
          console.log(
            "social media catch error ==>>",
            err?.response?.data?.message
          )
        )
        .finally(() => {
          history.goBack();
        });
      // console.log(allowAppsDBPayload)
    } else if (pathname === "/screen-shot-select-apps") {
      const allowAppsDBPayload = normalFormattedAllowedApps?.map((item) => {
        return {
          appId: item?.id,
          appUuid: item?.appUuid?.toString(),
          isAllow: item?.screenshotEnable ? 1 : 0,
        };
      });

      dbPayloadToAllowedApp["screenshotApps"] = [...allowAppsDBPayload];

      screenshotSettings(dbPayloadToAllowedApp)
        .then((res) => {})
        .catch((err) =>
          console.log(
            "screenshot app update catch error ==>>",
            err?.response?.data?.message
          )
        )
        .finally(() => {
          history.goBack();
        });
    } else if (pathname === "/keystrokes-select-apps") {
      const allowAppsDBPayload = normalFormattedAllowedApps?.map((item) => {
        return {
          appId: item?.id,
          IsKeystrokeEnable: item?.isKeystrokeEnabled ? 1 : 0,
        };
      });

      dbPayloadToAllowedApp["keystrokeAppStatus"] = [...allowAppsDBPayload];

      appKeyStrokesStatus(dbPayloadToAllowedApp)
        .then((res) => {})
        .catch((err) =>
          console.log(
            "keystokes app update catch error ==>>",
            err?.response?.data?.message
          )
        )
        .finally(() => {
          history.goBack();
        });
    }
  }

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap align-items-center separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div
                  className="d-inline-flex align-items-center lh-1 c-pointer fs-5"
                  onClick={() => history.goBack()}
                >
                  {/* <Link to={history.goBack()} className="text-blue-900 fs-5"> */}
                  <i className="icon-arrow-left" />
                  {/* </Link> */}
                  <h3 className="text-blue-900 mb-0">
                    {getLangTranslation(
                      "SCREENSHOTS_SELECT_APPS",
                      "SELECT APPS"
                    )}
                  </h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              <span className="icon-wrap icon-rounded me-2 p-0 overflow-hidden ratio ratio-1x1 border-0">
                <img src={getImage(kid?.image, kid?.gender)} alt="" />
              </span>
              <div className="list-content">
                <h5 className="text-blue-900 mb-0">{kid?.childName}</h5>
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item content-300 w-100">
              <div className="select-with-icon">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>
                {/* <select
                  className="form-select text-dark single-select-text"
                  value={device || ""}
                  onChange={(e) => setDevice(e.target.value)}
                >
                  <option value="">Select</option>
                  {kidDevicesList?.map((item, index) => {
                    return (
                      <option value={item?.ID} key={index}>
                        {item?.Name}
                      </option>
                    );
                  })}
                </select>*/}
                <Select
                  className="custom-select "
                  classNamePrefix="custom-select"
                  placeholder="Select Device"
                  options={deviceOptions}
                  value={
                    deviceOptions?.find(
                      (item) => item?.value === selectedDeviceData?.ID
                    ) || ""
                  }
                  onChange={handleDeviceSelection}

                  isSearchable={false}
                />
              </div>
            </div>

            <SetRulesDisableSupervison
              deviceSelected={selectedDeviceData?.ID}
              enableSupervision={setRulesData?.enableSupervision}
              handleTimeSupervision={handleTimeSupervision}
            />
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-items-center flex-wrap justify-content-between gap-3 mb-6">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                name="allSelect"
                id="selectAll"
                disabled={normalFormattedAllowedApps?.length <= 0}
                checked={
                  normalFormattedAllowedApps?.length > 0 &&
                  normalFormattedAllowedApps?.every(
                    (item) => item[pathKeys[pathname]?.key]
                  )
                }
                onChange={handleScreenShotSelect}
              />
              <label className="form-check-label text-dark" htmlFor="selectAll">
                {getLangTranslation(
                  "MANAGE_NOTIFICATION_SELECT_ALL",
                  "Select All"
                )}
              </label>
            </div>
            <button
              className="btn btn-primary"
              type="button"
              onClick={handleAllowedAppsSave}
              disabled={loader || normalFormattedAllowedApps?.length === 0}
            >
              <span className="btn-upper-case">
                {getLangTranslation("SAVE", "Save")}
              </span>
            </button>
          </div>
          <div className="table-responsive">
            <table className="table table-striped ">
              <tbody>
                {allowedApps?.map((item, index) => {
                  return (
                    <ScreenShotTableRow
                      item={item}
                      key={index}
                      handleScreenShotSelect={handleScreenShotSelect}
                      pathKeys={pathKeys}
                      pathname={pathname}
                    />
                  );
                })}
              </tbody>
            </table>
          </div>
          {/* {console.log(normalFormattedAllowedApps)} */}
          {normalFormattedAllowedApps?.length === 0 && (
            <div className="text-center my-3">
              --{" "}
              {getLangTranslation(
                "PARENT_TASK_DATA_NOT_FOUND",
                "No data found !"
              )}{" "}
              --
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ScreenShotsSelectApps;
